module.exports = "/_next/static/resources/photo-beth-58c48274bfbdd9e8a52d899e8e3dc95f.jpg";